




























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitFileData } from '@/api/heritageUnit/unitBase'
import { UploadOptData, thumbnailServer } from '@/api/common/upload'
import { showVaildMsg } from '@/configs/validate'
import * as attApi from '@/api/common/attach'
import { newGuid } from '@/configs/functions'
import { imageFormat } from '@/configs/fileTypes'
import { putFile } from '@/api/heritageUnit/unitFour'
import Element from 'element-ui'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    FileCode: [{ required: true, message: '请输入编号', trigger: 'blur' }],
    FileName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
    FileMade: [{ required: true, message: '请输入制作人', trigger: 'blur' }],
    FileCreateDate: [
      { required: true, message: '请输入制作日期', trigger: 'blur' }
    ]
    // AttachId: [{ required: true, message: '请输入制作日期', trigger: 'blur' }]
  }
}
@Component({
  components: { FormDialog }
})
export default class UnitFileForm extends Vue {
  public name = 'UnitFileForm'
  public expandNames: string[] = ['info', 'pics']
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false
  get fileTypeName() {
    // var names = ['', '图纸', '照片', '图纸卷(四有)', '照片卷(四有)']
    var names = ['', '图纸', '照片', '图纸', '照片']
    return names[this.form.FileType] // == 1 ? '图纸' : '照片'
  }
  //是否马上保存，四有情况中的图纸修改后即时更新
  get saveData(): boolean {
    return this.form.FileType == 3 || this.form.FileType == 4
  }
  public refTarget: string = ''
  //每次调用组件都生成一个guid，用来在上传完成后的回传
  public uploadGuid: string = ''
  // get fileExt() {
  //   return this.form.FileType == 1 ? '.gif.jpg.jpeg.bmp.png.pdf' : '.gif.jpg.jpeg.bmp.png'
  // }
  public uploadOpt: UploadOptData = {
    isMulti: false, //是否支持多个附件，以列表展示
    exts: imageFormat, //格式限制 .pdf.doc.docx.png.jpg.gif
    refId: 0,
    refType: 0, // 从后台获取，refType=(byte)EnumHelper.AttachType.对应枚举
    guid: '' // newGuid() // 从后台获取，guid=Guid.NewGuid().ToString()
  }
  public emptyForm: UnitFileData = {
    Id: 0,
    UnitId: 0,
    FileType: 0, //0:图片 1:图纸 3四有中的图片(直接提交) 4四有中的图纸(直接提交)
    FileCode: '', // 代码
    FileName: '', // 名称
    AttachId: 0,
    FileCreateDate: new Date(), // 制作日期
    FileMade: '', // 制作人
    FileSpec: '',
    Specification: '',
    NewUserId: 0,
    NewDate: new Date(),

    FileTypeName: '',
    AttachType: 0,
    AttachGuid: '',
    AttInfo: attApi.emptyAttach
  }
  public form = Object.assign({}, this.emptyForm)
  public rules = getFormRules(this.form)

  public $refs!: {
    formData: Element.Form
  }
  public getFileUrl(f: attApi.AttachInfo) {
    return thumbnailServer(f.Id, f.TempGuid, f.Name)
  }
  public created() {
    // this.rules = getFormRules(this.form)
  }
  public mounted() {
    window.eventBus.$on('openUnitFileForm', (info: any) => {
      this.refTarget = info.targetId
      this.modifyData(info.data)
    })
    window.eventBus.$on('uploadComplete', (info: any) => {
      if (info.targetId == this.uploadGuid) {
        this.uploadOpt = info.opt
        this.getAttach()
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('openUnitFileForm')
    window.eventBus.$off('uploadComplete')
  }
  public showUploader() {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
    window.eventBus.$emit('openUploader', {
      targetId: this.uploadGuid,
      opt: this.uploadOpt
    })
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public modifyData(info: UnitFileData) {
    this.open()
    this.uploadGuid = newGuid()
    if (info.AttachId == 0 && info.AttachGuid == '') {
      info.AttachGuid = newGuid()
    }
    this.form = Object.assign({}, info)
    var exts = imageFormat
    if (this.refTarget.indexOf('_EighthUnit') > -1) {
      //第八批文保单位申报(河南)时定死为'.jpg.jpeg'
      exts = '.jpg.jpeg'
    }
    this.uploadOpt = {
      isMulti: false, //是否支持多个附件，以列表展示
      exts: exts, //格式限制 .pdf.doc.docx.png.jpg.gif
      refId: info.Id,
      refType: info.AttachType, // 从后台获取，refType=(byte)EnumHelper.AttachType.对应枚举
      guid: info.AttachGuid
    }
  }
  public sendData(data: UnitFileData) {
    window.eventBus.$emit('submitUnitFileForm', {
      targetId: this.refTarget,
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        var f = Object.assign({}, this.form)
        if (f.AttachId == 0) {
          this.$message({
            message: `请上传${this.fileTypeName}!`,
            type: 'warning'
          })
          return false
        } else {
          if (this.saveData) {
            putFile(f.Id, f).then(
              (response: { data: any }) => {
                const data = response.data
                const msg = f.Id > 0 ? '保存' : '创建'
                if (data && !data.IsError) {
                  this.$message({
                    message: `${msg}成功`,
                    type: 'success'
                  })
                  //如果是新增，需要获取新增后的Id
                  f.Id = data.DataId
                  this.sendData(f)
                  this.close()
                } else {
                  this.$message({
                    dangerouslyUseHTMLString: true, message: `${data.Message}`,
                    type: 'warning'
                  })
                }
              },
              (data: any) => {
                console.log(data)
              }
            )
          } else {
            this.sendData(f)
            this.close()
          }
        }
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
  public delAttach(id: number) {
    this.$confirm(`确定要删除该${this.fileTypeName}吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        attApi.remove(id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.form.AttachId = 0
          this.form.AttInfo = Object.assign({}, attApi.emptyAttach)
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }
  public getAttach() {
    var opt = this.uploadOpt
    attApi.getInfo(opt.refId, opt.refType, opt.guid)
      .then((response: { data: any }) => {
        var data = response.data
        if (data && data.Id > 0) {
          this.form.AttInfo = data
          this.form.AttachId = data.Id
          if (this.form.FileName == '') {
            const fileName = data.Name
            //去掉后缀名
            var name = fileName.substr(0, fileName.lastIndexOf('.'))
            this.form.FileName = name
          }
        }
      })
  }
}
